<script>
export default {
  name: "loadingSkeleton",
  props: {
    loadingText: ''
  }
}
</script>

<template>
  <div class="loading-bar rounded-border" style="display: flex; flex-direction: column; padding: 20px; width: inherit; height: max-content; margin: 10px;">
    <span style="display: flex; color: #003333; justify-content: center; align-items: center; margin-bottom: 20px">{{loadingText || 'Loading...'}}</span>
    <el-row>
      <el-col :span="24">
        <el-row style="height: 150px; width: 100%; background-color: #cccccc; margin-bottom: 10px" class="rounded-border">
          <el-col :span="24"></el-col>
        </el-row>
        <el-row style="height: 20px; width: 100%; background-color: #cccccc; margin-bottom: 10px" class="rounded-border">
          <el-col :span="24"></el-col>
        </el-row>
        <el-row style="height: 20px; width: 100%; background-color: #cccccc; margin-bottom: 10px" class="rounded-border">
          <el-col :span="24"></el-col>
        </el-row>
        <el-row style="height: 20px; width: 100%; background-color: #cccccc; margin-bottom: 10px" class="rounded-border">
          <el-col :span="24"></el-col>
        </el-row>
        <el-row style="height: 150px; width: 100%; background-color: #cccccc; margin-bottom: 10px" class="rounded-border">
          <el-col :span="24"></el-col>
        </el-row>
        <el-row style="height: 20px; width: 100%; background-color: #cccccc; margin-bottom: 10px" class="rounded-border">
          <el-col :span="24"></el-col>
        </el-row>
        <el-row style="height: 20px; width: 100%; background-color: #cccccc; margin-bottom: 10px" class="rounded-border">
          <el-col :span="24"></el-col>
        </el-row>
        <el-row style="height: 20px; width: 100%; background-color: #cccccc;" class="rounded-border">
          <el-col :span="24"></el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped>

.loading-bar {
  position: relative;
  overflow: hidden;
  background-color: #ececec;
  border-radius: 4px;
}
.loading-bar::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);
  animation: loading-bar 1.5s infinite;
}

@keyframes loading-bar {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

.rounded-border {
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/package/loadingSkeleton.vue